<div>

  <mat-accordion>


    <mat-expansion-panel (opened)="panelOpenState1 = true"
                                         (closed)="panelOpenState1 = false">
      <mat-expansion-panel-header>
        <mat-panel-title>General Settings</mat-panel-title>
      </mat-expansion-panel-header>
      <div class="shadowBox row">

        <div class="col-sm-5" style="margin: 0px; padding: 0px;">
          <br>
          <p style="font-weight: bold;">Display Name:</p>
          <p style="font-weight: bold;">IP Address:</p>
          <p style="font-weight: bold;">MAC Address:</p>
          <p style="font-weight: bold;">Time Zone:</p>
          <p style="font-weight: bold;">System Password:</p>

        </div>

        <div class="col-sm-6"  style="margin: 0px; padding: 0px;">
          <br>
          <p>{{endpoint_data.system_name?endpoint_data.system_name:"NA"}}</p>
          <p>{{endpoint_data.system_ip?endpoint_data.system_ip:"NA"}}</p>
          <p>{{endpoint_data.system_mac_address?endpoint_data.system_mac_address:"NA"}}</p>
          <p>{{endpoint_data.system_time_zone?endpoint_data.system_time_zone:"NA"}}</p>
          <p [ngStyle]="{'color': (endpoint_data.system_password==1) ? '#000000' : '#FF0000	'}">{{endpoint_data.system_password?"**********":"System password does not exist."}}</p>

        </div>

      </div>
    </mat-expansion-panel>


    <mat-expansion-panel (opened)="panelOpenState2 = true"
                                         (closed)="panelOpenState2 = false">
      <mat-expansion-panel-header>
        <mat-panel-title>Software and Product Information</mat-panel-title>
      </mat-expansion-panel-header>
      <div class="shadowBox row">

        <div class="col-sm-5" style="margin: 0px; padding: 0px;">
          <br>
          <p style="font-weight: bold;">Software Name:</p>
          <p style="font-weight: bold;">Software Version:</p>
          <p style="font-weight: bold;">Serial Number:</p>
          <p style="font-weight: bold;">Product ID:</p>
        </div>

        <div class="col-sm-6"  style="margin: 0px; padding: 0px;">
          <br>
          <p>{{endpoint_data.software_name?endpoint_data.software_name:"NA"}}</p>
          <p>{{endpoint_data.software_version?endpoint_data.software_version:"NA"}}</p>
          <p>{{endpoint_data.serial_number?endpoint_data.serial_number:"NA"}}</p>
          <p>{{endpoint_data.product_id?endpoint_data.product_id:"NA"}}</p>
        </div>

      </div>
    </mat-expansion-panel>


    <mat-expansion-panel (opened)="panelOpenState3 = true"
                                         (closed)="panelOpenState3 = false">
      <mat-expansion-panel-header>
        <mat-panel-title>Network Settings</mat-panel-title>
      </mat-expansion-panel-header>
      <div class="shadowBox row">

        <div class="col-sm-5" style="margin: 0px; padding: 0px;">
          <br>
          <p style="font-weight: bold;">DNS Server 1:</p>
          <p style="font-weight: bold;">DNS Server 2:</p>
          <p style="font-weight: bold;">DNS Server 3:</p>
          <p style="font-weight: bold;">DNS Domain Name:</p>

          <p style="font-weight: bold;">NTP Server:</p>
          <p style="font-weight: bold;">H323 State:</p>
          <p style="font-weight: bold;">H323 Gatekeeper Address:</p>
          <p style="font-weight: bold;">H323 Gatekeeper Port:</p>
          <p style="font-weight: bold;">H323 Gatekeeper Status:</p>
          <p style="font-weight: bold;">H323 Gatekeeper Reason:</p>
          <p style="font-weight: bold;">H323 Gatekeeper Mode:</p>
          <p style="font-weight: bold;">H323 Alias E164:</p>
          <p style="font-weight: bold;">H323 Alias ID:</p>

          <p style="font-weight: bold;">SIP Display Name::</p>
          <p style="font-weight: bold;">SIP State:</p>
          <p style="font-weight: bold;">SIP Proxy Address 1:</p>
          <p style="font-weight: bold;">SIP Proxy Address 1 Status:</p>
          <p style="font-weight: bold;">SIP Proxy Address 2:</p>
          <p style="font-weight: bold;">SIP Proxy Address 2 Status:</p>
          <p style="font-weight: bold;">SIP Registration Status:</p>
          <p style="font-weight: bold;">SIP Registration URI:</p>
          <p style="font-weight: bold;">SIP Listen Port:</p>
          <p style="font-weight: bold;">SIP TLS Verify:</p>
          <p style="font-weight: bold;">SIP Authentication:</p>
          <p style="font-weight: bold;">SIP Authentication Username:</p>
          <p style="font-weight: bold;">SIP Authentication Password:</p>

        </div>

        <div class="col-sm-6"  style="margin: 0px; padding: 0px;">
          <br>
          <p>{{endpoint_data.dns_server1?endpoint_data.dns_server1:"NA"}}</p>
          <p>{{endpoint_data.dns_server2?endpoint_data.dns_server2:"NA"}}</p>
          <p>{{endpoint_data.dns_server3?endpoint_data.dns_server3:"NA"}}</p>
          <p>{{endpoint_data.dns_domain_name?endpoint_data.dns_domain_name:"NA"}}</p>

          <p>{{endpoint_data.ntp_server1?endpoint_data.ntp_server1:"NA"}}</p>
          <p>{{endpoint_data.enable_h323?endpoint_data.enable_h323:"NA"}}</p>
          <p>{{endpoint_data.h323_gatekeeper_address?endpoint_data.h323_gatekeeper_address:"NA"}}</p>
          <p>{{endpoint_data.h323_gatekeeper_port?endpoint_data.h323_gatekeeper_port:"NA"}}</p>
          <p>{{endpoint_data.h323_gatekeeper_status?endpoint_data.h323_gatekeeper_status:"NA"}}</p>
          <p>{{endpoint_data.h323_gatekeeper_reason?endpoint_data.h323_gatekeeper_reason:"NA"}}</p>
          <p>{{endpoint_data.h323_gatekeeper_mode?endpoint_data.h323_gatekeeper_mode:"NA"}}</p>
          <p>{{endpoint_data.h323_e164?endpoint_data.h323_e164:"NA"}}</p>
          <p>{{endpoint_data.h323_id?endpoint_data.h323_id:"NA"}}</p>

          <p>{{endpoint_data.sip_display_name?endpoint_data.sip_display_name:"NA"}}</p>
          <p>{{endpoint_data.enable_sip?endpoint_data.enable_sip:"NA"}}</p>
          <p>{{endpoint_data.sip_proxy_address?endpoint_data.sip_proxy_address:"NA"}}</p>
          <p>{{endpoint_data.sip_proxy_address_status?endpoint_data.sip_proxy_address_status:"NA"}}</p>
          <p>{{endpoint_data.sip_proxy_address2?endpoint_data.sip_proxy_address2:"NA"}}</p>
          <p>{{endpoint_data.sip_proxy_address2_status?endpoint_data.sip_proxy_address2_status:"NA"}}</p>
          <p>{{endpoint_data.sip_registration_status?endpoint_data.sip_registration_status:"NA"}}</p>
          <p>{{endpoint_data.sip_registration_uri?endpoint_data.sip_registration_uri:"NA"}}</p>

          <p>{{endpoint_data.sip_listen_port?endpoint_data.sip_listen_port:"NA"}}</p>
          <p>{{endpoint_data.sip_tls_verify?endpoint_data.sip_tls_verify:"NA"}}</p>
          <p>{{endpoint_data.sip_authentication?endpoint_data.sip_authentication:"NA"}}</p>
          <p>{{endpoint_data.sip_authentication_username?endpoint_data.sip_authentication_username:"NA"}}</p>
          <p>{{endpoint_data.sip_authentication_password?"***********":"NA"}}</p>

        </div>

      </div>
    </mat-expansion-panel>


    <mat-expansion-panel (opened)="panelOpenState4 = true"
                                         (closed)="panelOpenState4 = false">
      <mat-expansion-panel-header>
        <mat-panel-title>Address Book</mat-panel-title>
      </mat-expansion-panel-header>
      <div class="shadowBox row">

        <div class="col-sm-5" style="margin: 0px; padding: 0px;">
          <br>
          <p style="font-weight: bold;">Address Book State:</p>
          <p style="font-weight: bold;">Address Book:</p>
        </div>

        <div class="col-sm-6"  style="margin: 0px; padding: 0px;">
          <br>
          <p>{{endpoint_data.enable_phonebook?endpoint_data.enable_phonebook:"NA"}}</p>
          <p>{{endpoint_data.phonebook_fk_id?endpoint_data.phonebook_fk_id:"NA"}}</p>
        </div>

      </div>
    </mat-expansion-panel>

    <mat-expansion-panel (opened)="panelOpenState5 = true"
                                          (closed)="panelOpenState5 = false"
                                          [expanded]="panelOpenState5">
      <mat-expansion-panel-header>
        <mat-panel-title>Notes</mat-panel-title>
      </mat-expansion-panel-header>
      <div class="shadowBox row">

        <div class="col-sm-5" style="margin: 0px; padding: 0px;">
          <br>
          <p style="font-weight: bold;">Notes on unit:</p>
          <p style="font-weight: bold;">Unit remedy tickets:</p>

        </div>

        <div class="col-sm-6"  style="margin: 0px; padding: 0px;">
          <br>
          <p>{{endpoint_data.ops_note?endpoint_data.ops_note:"No notes were placed on this unit."}}</p>
          <p>{{endpoint_data.remedy_opened_ticket?endpoint_data.remedy_opened_ticket:"No remedy tickets exists."}}</p>

        </div>

      </div>
    </mat-expansion-panel>

  </mat-accordion>
  <div class="text-center mt-2" *ngIf="endpoint_warnings.length>0">
    <p *ngFor="let warning of endpoint_warnings" style="color:red">* {{warning}}</p>
  </div>
  <div class="text-center mt-2" id="buttons">
    <button mat-raised-button  color="primary"
                 type="submit" style="margin-right: 5px;"
                 [disabled]="endpoint_warnings.length>0 || pullSystemFlag"
                  (click)="pullDataFromSystem()">
      <span style="margin: 0px;padding: 0px;" >Pull from system</span>
    </button>
    <button mat-raised-button  color="warn" *ngIf="adminAuthorization" [disabled]="deleteSystemFlag"
                 type="submit" style="margin-left: 5px;" (click)="openDialog()">
      <span style="margin: 0px;padding: 0px;">Delete system</span>
    </button>
  </div>
  <div class="text-center mt-2" *ngIf="endpoint_warnings.length>0">
    <p style="color:red">* Pull system is disabled until all warnings shown above in red are resolved.</p>
  </div>
</div>
